import { render, staticRenderFns } from "./user_index.vue?vue&type=template&id=72e2813a&"
import script from "./user_index.vue?vue&type=script&lang=js&"
export * from "./user_index.vue?vue&type=script&lang=js&"
import style0 from "./user_index.vue?vue&type=style&index=0&id=72e2813a&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports